var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoInprogressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_inprogress_icon",
    transform: "translate(-240 -1184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 26,
    height: 26,
    transform: "translate(240 1184)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(240 1184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1 1)",
    fill: "#afb4c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M6.712,4.5H.954A.954.954,0,0,0,0,5.454v5.758a.954.954,0,0,0,.954.954H6.712a.954.954,0,0,0,.954-.954V5.454A.954.954,0,0,0,6.712,4.5Zm3.781.753L8.306,6.762V9.9l2.188,1.507A.64.64,0,0,0,11.5,10.9V5.768A.64.64,0,0,0,10.494,5.253Z",
    transform: "translate(8 4.667)",
    fill: "#fefefe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoInprogressIcon);
export default __webpack_public_path__ + "static/media/video_inprogress_icon.3601be17a39b76fd5b5cfade83f0d40a.svg";
export { ForwardRef as ReactComponent };